import { render, staticRenderFns } from "./historicalData.vue?vue&type=template&id=b1738fd6&scoped=true"
import script from "./historicalData.vue?vue&type=script&lang=js"
export * from "./historicalData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1738fd6",
  null
  
)

export default component.exports